import { formatCurrency, FormContainer, LabeledInput, Worksheet } from "uikit"
import React from "react"
import { Dropdown, Input } from "semantic-ui-react"
import { useStore } from "store"
import { Footer } from "./Footer"

const CharityForm = ({
  data: {
    fields: { description, start_year, amount, years_duration },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Done",
  submitHeader = "",
  onDelete,
  baseUrl,
  yearOptions,
  getYearDurationOptions,
  isNew,
  generalSpending,
  currentYear
}) => (
  <Worksheet error={error}>
    <Worksheet.Body>
      <Worksheet.Row label="What is the name of this goal?">
        <Worksheet.Field error={description.error}>
          <Input {...description} autoComplete="off" />
        </Worksheet.Field>
      </Worksheet.Row>
      <Worksheet.Row label="How much do need for this goal each year?">
        <Worksheet.Field error={amount.error}>
          <LabeledInput
            {...amount}
            label=""
            iconText="$"
            iconPosition="left"
            placeholder="0"
          />
        </Worksheet.Field>
      </Worksheet.Row>
      <Worksheet.Row
        label="What is the start year for the goal?"
        description={
          start_year && parseInt(start_year.value, 10) === currentYear
            ? `The ${
                amount && amount.value !== ""
                  ? typeof base_amount === "number"
                    ? formatCurrency(amount.value)
                    : "$" + amount.value
                  : "$0"
              } will be in addition to your ${formatCurrency(
                generalSpending
              )} General Spending amount.`
            : null
        }
      >
        <Worksheet.Field error={start_year.error}>
          <Dropdown
            selection
            {...start_year}
            fluid
            placeholder="Year"
            options={yearOptions}
            onChange={(event, data) => {
              years_duration.onChange(event, { value: 1 })
              start_year.onChange(event, data)
            }}
          />
        </Worksheet.Field>
      </Worksheet.Row>
      <Worksheet.Row label="How many years will the goal last?">
        <Worksheet.Field error={years_duration.error}>
          <Dropdown
            selection
            {...years_duration}
            fluid
            placeholder="Year"
            options={getYearDurationOptions(start_year.value)}
          />
        </Worksheet.Field>
      </Worksheet.Row>
    </Worksheet.Body>

    <Footer
      baseUrl={baseUrl}
      isNew={isNew}
      submitLabel={submitLabel}
      onSubmit={onSubmit}
      isPending={isPending}
      onDelete={onDelete}
      isModified={isModified}
      deleteLabel="Delete Goal"
      error={error}
    />
  </Worksheet>
)

const CharityFormContainer = FormContainer(
  {
    description: {
      type: "string"
    },
    start_year: {
      type: "unit",
      useGrouping: false
    },
    amount: {
      type: "unit",
      minValue: 500
    },
    years_duration: {
      type: "unit",
      defaultValue: 1,
      minValue: 1
    },
    type: {
      type: "string",
      defaultValue: "charity"
    }
  },
  (fields, ...form) => {}
)(CharityForm)

const Charity = ({ household, goal, scenario, ...formProps }) => {
  const [people] = useStore("householdPeople", household.id)
  const [scenarios, { addGoal, updateGoal, deleteGoal }] = useStore(
    "householdScenarios",
    household.id
  )
  const isNew = goal === null

  let values = {}

  const clientInfo = Object.values(people).find(
    person => person.role === "client"
  )

  const maxYear = new Date(clientInfo.birth_date).getFullYear() + 100
  let currentYear = new Date().getFullYear()
  let yearCount = Math.abs(maxYear - currentYear + 1)

  const yearOptions = Array(yearCount)
    .fill()
    .map((_, i) => ({
      value: currentYear + i + "",
      text: currentYear + i
    }))

  const getYearDurationOptions = start_year => {
    if (start_year > 0) {
      const durationOptionCount = maxYear - start_year + 1
      return Array(durationOptionCount)
        .fill(0)
        .map((_, i) => {
          const value = i + 1 + ""
          return {
            value,
            text: i === 0 ? `${value} Year` : `${value} Years`
          }
        })
    } else return []
  }

  if (!isNew) {
    values = { ...goal }
  }
  const generalSpending =
    Object.values(scenarios) && Object.values(scenarios).length > 0
      ? Object.values(scenarios)[0].general_spending
      : 0

  const submit = isNew
    ? async values =>
        await addGoal({
          scenario_id: scenario.id,
          household_id: household.id,
          ...values
        })
    : async values => await updateGoal({ id: goal.id, ...values })

  const onDelete = async () => {
    await deleteGoal({ id: goal.id, scenario_id: scenario.id })
    return true
  }
  return (
    <CharityFormContainer
      {...{
        submit,
        onDelete,
        values,
        yearOptions,
        getYearDurationOptions,
        isNew,
        generalSpending,
        currentYear,
        ...formProps
      }}
    />
  )
}

export default Charity
